var React = require('react');

function Alignright (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.89 4.14h22.22M8.96 7.57h17.15M3.89 11h22.22M8.96 14.43h17.15M3.89 17.86h22.22"}));
}

Alignright.defaultProps = {"viewBox":"0 0 30 22"};

module.exports = Alignright;

Alignright.default = Alignright;
